<template>
    <div>
        <el-card shadow='never'>
            <div slot='header' class='clearfix'>
                <span>商品支付成功后数据映射配置</span>
            </div>
            <el-form label-position='top'>
                <el-form-item label='选择'>
                    <el-select clearable @change='handleSaveTypeChange' size='mini' v-model='productSaveType'
                               placeholder='请选择'>
                        <el-option
                            v-for='item in saveOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <template v-if='productSaveType === "CLOUD_STORAGE"'>
                    <el-form-item label='选择存储应用'>
                        <el-select size='mini' v-model='selectedAppId' placeholder='请选择应用'
                                   @change='handleAppChange'>
                            <el-option
                                v-for='item in appOptions'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label='可用变量'>
                        <el-alert
                            style='margin-bottom: 1rem'
                            :title='getCloudStorageTitle'
                            type='success'
                            :closable='false'>
                        </el-alert>
                        <el-collapse v-model='activeVariableCollapse'>
                            <el-collapse-item title='点击展开查看所有可用变量' name='variables'>
                                <div class='variable-tags'>
                                    <el-tag
                                        v-for='item in orderInfoOptions'
                                        :key='item.value'
                                        size='mini'
                                        type='info'
                                        @click='copyVariable(item)'
                                        style='margin: 2px 4px; cursor: pointer;'>
                                        <el-tooltip :content='item.label' placement='top'>
                                            <span>{{ item.value }}</span>
                                        </el-tooltip>
                                    </el-tag>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </el-form-item>
                    
                    <el-form-item>
                        <template slot='label'>
                            <span>Class发货配置</span>
                            <el-button
                                size='mini'
                                type='primary'
                                icon='el-icon-plus'
                                style='margin-left: 10px;'
                                @click='handleAddClass'>
                                添加Class修改语句
                            </el-button>
                        </template>
                        
                        <div v-if='classConfigList.length === 0' style='color: #909399; font-size: 12px;'>
                            暂无Class配置，请点击"添加Class修改语句"按钮添加
                        </div>
                        
                        <el-card
                            v-for='(classConfig, index) in classConfigList'
                            :key='index'
                            shadow='hover'
                            style='margin-bottom: 10px;'>
                            <el-row type='flex' align='middle' style='margin-bottom: 10px;'>
                                <el-col :span='16'>
                                    <span style='margin-right: 10px;'>Class:</span>
                                    <el-select
                                        size='mini'
                                        v-model='classConfig.className'
                                        placeholder='请选择Class'
                                        style='width: 200px;'
                                        @change='handleClassChange(index)'>
                                        <el-option
                                            v-for='item in getAvailableClassOptions(index)'
                                            :key='item.value'
                                            :label='item.label'
                                            :value='item.value'>
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span='8' style='text-align: right;'>
                                    <el-button
                                        size='mini'
                                        type='text'
                                        icon='el-icon-document'
                                        @click='handleShowTemplate(index)'>
                                        模板
                                    </el-button>
                                    <el-button
                                        size='mini'
                                        type='text'
                                        icon='el-icon-view'
                                        @click='handlePreviewJson(classConfig)'>
                                        预览
                                    </el-button>
                                    <el-button
                                        size='mini'
                                        type='text'
                                        icon='el-icon-delete'
                                        style='color: #F56C6C;'
                                        @click='handleRemoveClass(index)'>
                                        删除
                                    </el-button>
                                </el-col>
                            </el-row>
                            <div>
                                <span style='font-size: 12px; color: #606266;'>修改语句(JSON):</span>
                                <el-input
                                    type='textarea'
                                    v-model='classConfig.updateStatement'
                                    :rows='4'
                                    :placeholder='classConditionTip'
                                    @blur='submitConfig'>
                                </el-input>
                            </div>
                        </el-card>
                    </el-form-item>
                </template>
                
                <template v-if='productSaveType === "CLOUD_FUNCTION"'>
                    <el-form-item label='选择云函数'>
                        <el-select size='mini' v-model='selectedFunctionName' placeholder='请选择云函数'
                                   style='width: 300px'
                                   @change='submitConfig'>
                            <el-option
                                v-for='item in cloudFunctionOptions'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                                <span style='float: left'>{{ item.label }}</span>
                                <span style='float: right; color: #8492a6; font-size: 13px'>{{ item.description
                                    }}</span>
                            </el-option>
                        </el-select>
                        <div style='margin-top: 5px; color: #909399; font-size: 12px;'>
                            支付成功后将异步触发该云函数。
                        </div>
                    </el-form-item>
                </template>
            </el-form>
        </el-card>
        
        <el-dialog title='JSON预览' :visible.sync='openJsonPreview' width='50%' append-to-body>
            <vue-json-pretty :data='previewJsonData' />
        </el-dialog>
        
        <el-dialog title='选择模板' :visible.sync='openTemplateDialog' width='50%' append-to-body>
            <el-collapse accordion>
                <el-collapse-item v-for='(template, index) in statementTemplates' :key='index'>
                    <template slot='title'>
                        <el-row type='flex' align='middle' style='width: 100%;'>
                            <el-col :span='18'>
                                <span style='font-weight: bold;'>{{ template.desc }}</span>
                            </el-col>
                            <el-col :span='6' style='text-align: right;'>
                                <el-button
                                    size='mini'
                                    type='primary'
                                    @click.stop='handleSelectTemplate(template)'>
                                    插入
                                </el-button>
                            </el-col>
                        </el-row>
                    </template>
                    <vue-json-pretty :data='parseTemplateValue(template.value)' />
                </el-collapse-item>
            </el-collapse>
        </el-dialog>
    </div>
</template>

<script>
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import { message } from '@/utils/message';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import { cloudFunctionApi } from '@/components/api/Other/cloudFunctionApi';
import { copyContent } from '@/utils/string/cottonPlugin';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    name: 'ProductShippingConfig',
    components: {
        VueJsonPretty
    },
    props: {
        projectInfoList: {
            type: Array
        },
        projectName: {
            type: String
        },
        additionalConfig: {
            type: String
        }
    },
    emits: ['submitConfig'],
    data() {
        return {
            projectInfoMap: new Map,
            projectAppId: undefined,
            appOptions: [],
            classOptions: [],
            selectedAppId: undefined,
            cloudFunctionOptions: [],
            selectedFunctionName: undefined,
            classConfigList: [],
            orderInfoOptions: [
                { 'label': '订单号', 'value': 'order_id' },
                { 'label': '用户userId', 'value': 'order_userId' },
                { 'label': '支付平台', 'value': 'order_provider' },
                { 'label': '实付金额', 'value': 'order_receiptAmount' },
                { 'label': '客户端自定义配置', 'value': 'order_clientCustomConfig' },
                { 'label': '订单创建时间', 'value': 'order_createTime' },
                { 'label': '支付时间', 'value': 'order_paidTime' },
                
                // 商品
                { 'label': '商品Id', 'value': 'product_productId' },
                { 'label': '商品名', 'value': 'product_name' },
                { 'label': '商品数量', 'value': 'product_produceCount' },
                { 'label': '商品价格', 'value': 'product_price' },
                { 'label': '限购数量', 'value': 'product_limitCount' }
            ],
            saveOptions: [
                {
                    label: '云存储',
                    value: 'CLOUD_STORAGE'
                },
                {
                    label: '云函数',
                    value: 'CLOUD_FUNCTION'
                }
            ],
            productSaveType: undefined,
            classConditionTip: '请输入JSON格式的修改语句，例如: {"coinCount": "{{product_produceCount}}"}',
            openJsonPreview: false,
            previewJsonData: {},
            activeVariableCollapse: [],
            openTemplateDialog: false,
            currentTemplateIndex: -1,
            statementTemplates: [
                {
                    desc: '增加金币数量',
                    value: '{"star":{"__op":"Increment","amount":"{{product_produceCount}}"}}'
                }
            ]
        };
    },
    created() {
        if (this.projectName) {
            this.init();
        }
        if (this.additionalConfig) {
            this.parseConfig();
        }
    },
    computed: {
        getCloudStorageTitle() {
            return '在修改语句中使用 {{变量名}} 格式引用变量，如{{order_userId}}, 使用变量占位时，请添加""引号。修改条件为objectId=下单用户的userId';
        }
    },
    watch: {
        projectInfoList() {
            this.init();
        },
        projectName() {
            this.init();
        },
        additionalConfig() {
            this.parseConfig();
        }
    },
    methods: {
        init() {
            this.productSaveType = undefined;
            this.appOptions = [];
            this.selectedAppId = undefined;
            this.classOptions = [];
            this.classConfigList = [];
            this.cloudFunctionOptions = [];
            this.selectedFunctionName = undefined;
            this.projectInfoMap = new Map;
            if (this.projectInfoList) {
                this.projectInfoList.forEach((t) => {
                    this.projectInfoMap.set(t.name, t.appId);
                    if (t.name === this.projectName) {
                        this.projectAppId = t.appId;
                    }
                });
            }
        },
        parseConfig() {
            // 先重置状态
            this.productSaveType = undefined;
            this.selectedAppId = undefined;
            this.classOptions = [];
            this.classConfigList = [];
            this.selectedFunctionName = undefined;
            
            if (!this.additionalConfig || this.additionalConfig === '{}') {
                return;
            }
            try {
                let additionalConfig = JSON.parse(this.additionalConfig);
                let config = additionalConfig.config;
                let productSaveType = additionalConfig.productSaveType;
                this.productSaveType = productSaveType;
                
                if (productSaveType === 'CLOUD_STORAGE' && config) {
                    this.loadCloudApplication().then(() => {
                        this.selectedAppId = config.appId;
                        this.loadClassOptions(config.appId).then(() => {
                            // 解析 batchUpdateDefinitions
                            let batchUpdateDefinitions = config.batchUpdateDefinitions;
                            if (batchUpdateDefinitions) {
                                this.classConfigList = [];
                                Object.keys(batchUpdateDefinitions).forEach(className => {
                                    this.classConfigList.push({
                                        className: className,
                                        updateStatement: batchUpdateDefinitions[className]
                                    });
                                });
                            }
                        });
                    });
                } else if (productSaveType === 'CLOUD_FUNCTION' && config) {
                    this.loadCloudFunctionOptions().then(() => {
                        this.selectedFunctionName = config.functionName;
                    });
                }
            } catch (e) {
                console.error('解析配置失败:', e);
            }
        },
        loadCloudApplication() {
            this.appOptions = [];
            return applicationCredentialApi.queryList().then(result => {
                if (result.code === 200) {
                    let appList = result.data;
                    if (!appList) {
                        message.error('未找到有效的云存储应用!');
                        return;
                    }
                    let filteredAppList = appList.filter(t => t.projectAppId === this.projectAppId);
                    filteredAppList.forEach((t) => {
                        this.appOptions.push({
                            label: t.chineseName,
                            value: t.appId
                        });
                    });
                    if (filteredAppList.length === 0) {
                        message.error('该项目未绑定云存储应用, 请先创建云存储应用!');
                    }
                }
            });
        },
        loadCloudFunctionOptions() {
            this.cloudFunctionOptions = [];
            if (!this.projectAppId) return Promise.resolve();
            return cloudFunctionApi.queryCloudFunctionList({
                projectAppId: this.projectAppId,
                type: 'PROJECT',
                pageNum: 1,
                pageSize: 1000
            }).then(res => {
                if (res.code === 200 && res.data) {
                    this.cloudFunctionOptions = (res.data.result || []).map(item => ({
                        label: item.name,
                        value: item.name,
                        description: item.description
                    }));
                }
            });
        },
        loadClassOptions(appId) {
            this.classOptions = [];
            return storageSchemaApi.queryAllSchema(appId).then(result => {
                if (result.code === 200) {
                    let schemaList = result.data.results;
                    schemaList.forEach((f) => {
                        this.classOptions.push({
                            label: f.objectId,
                            value: f.objectId
                        });
                    });
                }
            });
        },
        handleAppChange(appId) {
            this.classConfigList = [];
            this.classOptions = [];
            if (appId) {
                this.loadClassOptions(appId);
            }
            this.submitConfig();
        },
        handleAddClass() {
            if (!this.selectedAppId) {
                message.warning('请先选择存储应用');
                return;
            }
            this.classConfigList.push({
                className: undefined,
                updateStatement: ''
            });
        },
        handleRemoveClass(index) {
            this.classConfigList.splice(index, 1);
            this.submitConfig();
        },
        handleClassChange(index) {
            // 检查className是否重复
            const currentClassName = this.classConfigList[index].className;
            const duplicateIndex = this.classConfigList.findIndex((item, i) =>
                i !== index && item.className === currentClassName
            );
            if (duplicateIndex !== -1) {
                message.error(`Class "${currentClassName}" 已存在，请选择其他Class`);
                this.classConfigList[index].className = undefined;
                return;
            }
            this.submitConfig();
        },
        getAvailableClassOptions(currentIndex) {
            // 过滤掉已被其他配置选中的Class
            const selectedClasses = this.classConfigList
                .filter((item, index) => index !== currentIndex && item.className)
                .map(item => item.className);
            return this.classOptions.filter(option => !selectedClasses.includes(option.value));
        },
        validateAndFormatJson(jsonStr) {
            if (!jsonStr || jsonStr.trim() === '') {
                return { valid: false, error: '修改语句不能为空' };
            }
            try {
                const parsed = JSON.parse(jsonStr);
                const formatted = JSON.stringify(parsed, null, 2);
                return { valid: true, formatted: formatted };
            } catch (e) {
                return { valid: false, error: '不是有效的JSON格式' };
            }
        },
        submitConfig() {
            let config = {
                productSaveType: this.productSaveType,
                config: {}
            };
            
            if (this.productSaveType === 'CLOUD_STORAGE') {
                // 构建新格式的配置
                let batchUpdateDefinitions = {};
                this.classConfigList.forEach((item) => {
                    if (item.className && item.updateStatement) {
                        const result = this.validateAndFormatJson(item.updateStatement);
                        if (result.valid) {
                            batchUpdateDefinitions[item.className] = result.formatted;
                        } else {
                            message.error(`对${item.className}的修改语句无效`);
                        }
                    }
                });
                
                config.config = {
                    appId: this.selectedAppId,
                    batchUpdateDefinitions: batchUpdateDefinitions
                };
                
                this.$emit('submitConfig', config);
            } else if (this.productSaveType === 'CLOUD_FUNCTION') {
                config.config = {
                    functionName: this.selectedFunctionName
                };
                this.$emit('submitConfig', config);
            } else {
                this.$emit('submitConfig', null);
            }
        },
        handleSaveTypeChange() {
            if (this.productSaveType === 'CLOUD_STORAGE') {
                this.selectedAppId = undefined;
                this.classOptions = [];
                this.classConfigList = [];
                this.loadCloudApplication();
            } else if (this.productSaveType === 'CLOUD_FUNCTION') {
                this.selectedFunctionName = undefined;
                this.loadCloudFunctionOptions();
            }
            this.submitConfig();
        },
        copyVariable(item) {
            copyContent('{{' + item.value + '}}');
        },
        handlePreviewJson(classConfig) {
            if (!classConfig.updateStatement || classConfig.updateStatement.trim() === '') {
                message.warning('修改语句为空');
                return;
            }
            try {
                this.previewJsonData = JSON.parse(classConfig.updateStatement);
                this.openJsonPreview = true;
            } catch (e) {
                message.error('JSON格式不正确，无法预览');
            }
        },
        handleShowTemplate(index) {
            this.currentTemplateIndex = index;
            this.openTemplateDialog = true;
        },
        handleSelectTemplate(template) {
            if (this.currentTemplateIndex === -1) {
                return;
            }
            const currentConfig = this.classConfigList[this.currentTemplateIndex];
            if (!currentConfig.updateStatement) {
                currentConfig.updateStatement = template.value;
            } else {
                currentConfig.updateStatement += template.value;
            }
            this.openTemplateDialog = false;
            message.success('模板已插入');
        },
        parseTemplateValue(value) {
            try {
                return JSON.parse(value);
            } catch (e) {
                return { error: '无法解析JSON' };
            }
        }
    }
};
</script>

<style scoped lang='scss'>
.variable-tags {
    background-color: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
    max-height: 120px;
    overflow-y: auto;
}
</style>
